import mediaHelper from 'styled-media-helper';
import { GridTheme } from './gridTheme';

export const media = mediaHelper(GridTheme.breakpoints);

export const MOBILE_BREAKPOINT = '1366px';

export const LARGE_SCREEN_BREAKPOINT = '1800px';